import React, { useContext } from 'react';
import { Square } from '@manulife/mux-logos';
import PropTypes from '../../../node_modules/prop-types/index.js';
import i18n from '../../lang/i18n/index.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import MobileMenu from './MobileMenu.js';
import SideNavContext from './SideNavContext.js';
import { MainNavWrapper, BrandLogoComponent, MainNavList } from './styledComponents.js';
import { renderSelectedTabContent } from './utils.js';
import useTheme from '../../hooks/useTheme.js';
import useLang from '../../hooks/useLang.js';
import useNavigation from '../../hooks/useNavigation.js';
import useMedia from '../../hooks/useMedia.js';

var MainNav = function MainNav(_ref) {
  var children = _ref.children,
    mainNavRef = _ref.mainNavRef;
  var theme = useTheme();
  var lang = useLang();
  var _useNavigation = useNavigation(),
    mainNavWrapperRef = _useNavigation.mainNavWrapperRef;
  var _useContext = useContext(SideNavContext),
    brandLogoProps = _useContext.brandLogoProps,
    isWideMainNav = _useContext.isWideMainNav,
    mobileTabs = _useContext.mobileTabs,
    selectedTab = _useContext.selectedTab;
  var showHamburgerMenu = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_1024, "px)")],
  // media queries
  [true],
  // values corresponding to media query
  false // default value
  );

  var alt = brandLogoProps.alt,
    href = brandLogoProps.href,
    onClick = brandLogoProps.onClick;
  return showHamburgerMenu ? /*#__PURE__*/React.createElement(MobileMenu, null, children) : /*#__PURE__*/React.createElement(MainNavWrapper, {
    ref: mainNavWrapperRef,
    "data-testid": "main-nav",
    isWideMainNav: isWideMainNav,
    theme: theme
  }, theme.sideNav.brandLogo.showLogo && /*#__PURE__*/React.createElement(BrandLogoComponent, {
    "data-testid": "brand-link-or-button",
    as: href ? 'a' : 'button',
    href: href,
    "aria-label": alt || i18n[lang].sideNav.brandLogo,
    onClick: onClick,
    isWideMainNav: isWideMainNav,
    theme: theme,
    "aria-hidden": !href && !onClick,
    tabIndex: !href && !onClick ? '-1' : '0'
  }, /*#__PURE__*/React.createElement(Square.GREEN, {
    id: "brand-logo",
    "data-testid": "brand-logo",
    title: alt || i18n[lang].sideNav.brandLogo,
    style: {
      width: isWideMainNav ? theme.sideNav.brandLogo.width : '80px',
      height: isWideMainNav ? theme.sideNav.brandLogo.height : '80px'
    }
  })), children && /*#__PURE__*/React.createElement(MainNavList, {
    role: "menu",
    theme: theme
  }, renderSelectedTabContent(mobileTabs, selectedTab, children, mainNavRef)));
};
process.env.NODE_ENV !== "production" ? MainNav.propTypes = {
  children: PropTypes.node
} : void 0;
MainNav.defaultProps = {
  children: undefined
};
process.env.NODE_ENV !== "production" ? MainNav.displayName = 'MainNav' : void 0;
var MainNav$1 = MainNav;

export { MainNav$1 as default };
